// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Future from "rescript-future/src/Future.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";

function fromUrl(filename, url) {
  return Future.make(resolve => {
    let body = document.querySelector("body");
    let tempLink = document.createElement("a");
    tempLink.setAttribute("style", "display: none;");
    tempLink.setAttribute("href", url.href);
    tempLink.setAttribute("download", Stdlib_Option.getOr(filename, url.href));
    let match = tempLink.getAttribute("download");
    if (match == null) {
      tempLink.setAttribute("target", "_blank");
    }
    if (body == null) {
      resolve({
        TAG: "Error",
        _0: undefined
      });
      return;
    }
    if (tempLink !== undefined) {
      body.appendChild(tempLink);
      Primitive_option.valFromOption(tempLink).click();
      let timeoutId = setTimeout(() => {
        body.removeChild(tempLink);
        try {
          URL.revokeObjectURL(url.href);
          return resolve({
            TAG: "Ok",
            _0: undefined
          });
        } catch (exn) {
          return resolve({
            TAG: "Error",
            _0: undefined
          });
        }
      }, 200);
      return () => {
        clearTimeout(timeoutId);
      };
    }
    resolve({
      TAG: "Error",
      _0: undefined
    });
  });
}

function fromBlob(blob, filename) {
  return fromUrl(filename, new URL(URL.createObjectURL(new File([blob], filename))));
}

export {
  fromUrl,
  fromBlob,
}
/* No side effect */
